<template>
	<div
		:class="{ image__modal: true, 'image__modal--video': isVideo }"
		v-if="modalSrc"
		@click="closeImageModal"
	>
		<div
			:class="[
				'image__modal__wrapper flex ',
				{ 'image__modal__wrapper--video': isVideo },
			]"
		>
			<Close></Close>
			<video
				v-if="isVideo && mediaSrc"
				:src="mediaSrc"
				controls
				playsinline
				autoplay
				preload="auto"
				class="modal-video"
				@click.stop
			></video>
			<img v-else-if="mediaSrc" :src="mediaSrc" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import loadProtectedImage from "@/utils/loadProtectedImage";
import loadProtectedVideo from "@/utils/loadProtectedVideo";

import Close from "@/assets/img/times-circle-regular.svg";

const VIDEO_EXTENSIONS = [".mp4", ".webm", ".mov", ".m4v"];

export default {
	components: {
		Close,
	},
	data() {
		return {
			blobUrl: "",
		};
	},
	computed: {
		...mapState({ modalSrc: "imageModalSrc" }),
		...mapState(["token"]),
		mediaSrc() {
			return this.blobUrl;
		},
		isVideo() {
			if (!this.modalSrc) return false;
			const ext = this.modalSrc
				.substring(this.modalSrc.lastIndexOf("."))
				.toLowerCase();
			return VIDEO_EXTENSIONS.includes(ext);
		},
	},
	watch: {
		async modalSrc(newSrc) {
			// Clean up previous blob URL
			if (this.blobUrl) {
				URL.revokeObjectURL(this.blobUrl);
				this.blobUrl = "";
			}
			// Load new media if src is provided
			if (newSrc && this.token) {
				if (this.isVideo) {
					this.blobUrl = await loadProtectedVideo(newSrc, this.token);
				} else {
					this.blobUrl = await loadProtectedImage(newSrc, this.token);
				}
			}
		},
	},
	beforeDestroy() {
		if (this.blobUrl) {
			URL.revokeObjectURL(this.blobUrl);
		}
	},
	methods: {
		...mapActions(["closeImageModal"]),
	},
};
</script>

<style scoped>
.modal-video {
	max-width: 90vw;
	max-height: 90vh;
}

.image__modal--video svg {
	right: -30px;
}
</style>
